import {
  fetchApiGetV2,
  fetchApiPostV2,
  fetchApiPutV2,
  fetchApiV2,
  postFormHeaders,
} from "../../../../api/api";
import { Document } from "../documents/documentsApi";
import { updateWebsite } from "./websiteActions";

/** Nested favicon from GET/PUT `/website` and `setWebsiteFavicon` (Builder API v2: `url` only). */
export interface WebsiteFavicon {
  url: string;
}

export interface Website {
  uuid?: string;
  id?: number;
  name: string;
  baseFontSize: string;
  rowColor: string;
  elementColor: string;
  description: string;
  columnColor: string;
  contentWidthUnit: string;
  contentWidthSize: number;
  shopBRadius: string;
  status: string;
  tracking: string;
  type: string;
  useBrowserLanguage: number;
  parentCustomFileId: number;
  favicon?: WebsiteFavicon | null;
  defaultTypographyId?: number;
  subdomains?: unknown;
}

const WebsiteAPI = {
  loadWebsite,
  saveWebsite,
  publishWebsite,
  setWebsiteFavicon,
};
export default WebsiteAPI;

export function loadWebsite() {
  return fetchApiGetV2<Website>(`/website`, {}).then((res) => updateWebsite(res));
}

function saveWebsite(data: Website) {
  return fetchApiPutV2<Website>(`/website`, {
    ...data,
  }).then((x) => {
    updateWebsite({ ...x });
  });
}

function publishWebsite() {
  return fetchApiPostV2(`/publish`, {}, false)
    .then((res: any) => res.text())
    .then((res) => console.log("Publish website response: ", res));
}

function setWebsiteFavicon(file: File) {
  const data = new FormData();
  data.append("files[]", file);
  return fetchApiV2<{ website: Website; documents: Document[] }>(
    `/setWebsiteFavicon`,
    postFormHeaders(data)
  ).then((x) => updateWebsite(x.website));
}
